import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox } from 'antd';
import style from './IsUsedCustomerPriceTypeCheckbox.module.scss';

interface IIsUsedCustomerPriceTypeCheckbox {
	toggleIsUsedCustomerPriceType: () => void;
	isUsedCustomerPriceType: boolean;
}

const IsUsedCustomerPriceTypeCheckbox: React.FC<IIsUsedCustomerPriceTypeCheckbox> = ({
	toggleIsUsedCustomerPriceType,
	isUsedCustomerPriceType,
}) => {
	return (
		<Checkbox
			data-test="IsUsedCustomerPriceTypeCheckbox"
			name="isUsedCustomerPriceType"
			className={style.checkbox}
			onChange={toggleIsUsedCustomerPriceType}
			checked={isUsedCustomerPriceType}>
			<Text translationNameSpace="form" translationKey="useCustomerPriceTypeLabel" asFragment={true} />
		</Checkbox>
	);
};

export default React.memo(IsUsedCustomerPriceTypeCheckbox);
